module.exports = __webpack_public_path__ + "img/johnston-city-logo.57c8f786.jpg";